import {
    type CounterpartyTinIds,
    getTinErrorMessage,
    useReviewTinMutation,
    useRevokeTinReviewMutation,
} from "@api/counterpartyTin.api";
import { useToaster } from "@design-system/ToastMessages/useToaster";

interface UseTinReviewActionsParams {
    ids: CounterpartyTinIds;
    tinRevisionId: string;
}

export function useTinReviewActions({
    ids,
    tinRevisionId,
}: UseTinReviewActionsParams) {
    const toaster = useToaster();
    const reviewMutation = useReviewTinMutation(ids);
    const revokeMutation = useRevokeTinReviewMutation(ids);

    const markReviewed = () =>
        reviewMutation.mutate(tinRevisionId, {
            onSuccess: () => toaster.success("Marked tax ID as reviewed"),
            onError: (error) =>
                toaster.error(
                    getTinErrorMessage(error) ??
                        "Failed to mark tax ID as reviewed",
                ),
        });

    const undoReview = () =>
        revokeMutation.mutate(undefined, {
            onSuccess: () => toaster.success("Removed your review"),
            onError: () => toaster.error("Failed to remove your review"),
        });

    return {
        markReviewed,
        undoReview,
        isPending: reviewMutation.isPending || revokeMutation.isPending,
    };
}
